import React from "react";
import { Spinner as ReactstrapSpinner } from "reactstrap";

export const SPINNER_SIZES = {
  LG: "lg",
  MD: "md",
  SM: "sm",
  XS: "xs",
  XXS: "xxs",
} as const;

export type SpinnerSize = (typeof SPINNER_SIZES)[keyof typeof SPINNER_SIZES];

type SpinnerProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  size?: SpinnerSize;
  color?: string;
  classNames?: string;
};

const sizes: Record<SpinnerSize, string> = {
  lg: "4rem",
  md: "3rem",
  sm: "2rem",
  xs: "1.5rem",
  xxs: "1.2rem",
};

export const Spinner = ({
  size = SPINNER_SIZES.LG,
  color = "primary",
  classNames,
}: SpinnerProps) => (
  <ReactstrapSpinner
    className={classNames}
    data-testid="spinner-component"
    style={{
      width: sizes[size],
      height: sizes[size],
      color,
    }}
  />
);
